// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'object-case-multi';

export const Component = () => (
  <>
    <path d='M25 18.523 19.853 25H8l4.191-6.478L8 12h11.852zm-11.62.001L9.839 24h9.532l4.354-5.48L19.368 13H9.831z' />
    <path d='M8.3 0c.44 0 .782.244.929.684l.78 2.295h10.988c.244 0 .489.097.732.292.195.245.293.49.293.733v4.98h2.002a.96.96 0 0 1 .683.292c.195.196.293.44.293.734v5.284l-.976-1.236V10.01H20.83l-.008-.01h-8.57l-.973-3.018H4.004v15.993H7L6 24H4.003a.965.965 0 0 1-.683-.293.88.88 0 0 1-.341-.732v-4.98H.977a.966.966 0 0 1-.684-.295.965.965 0 0 1-.293-.682V.977C0 .733.098.488.293.293A.965.965 0 0 1 .977 0zM.979 17.017H2.98V6.982c0-.243.098-.488.341-.683a.966.966 0 0 1 .684-.293h7.275c.488 0 .782.243.929.682l.781 2.295h8.008v-4.98H9.278L8.302.976H.978z' />
  </>
);

export const viewBox = '0 0 25 25';
